import { Form, Templates } from "@rjsf/material-ui";
import { RJSFSchema } from "@rjsf/utils";
import validator from "@rjsf/validator-ajv8";
import styled from "styled-components";
import React from "react";
import ObjectFieldTemplate from "./ObjectFiledTemplate";
import CustomArrayFieldTemplate from "./CustomArrayFieldTemplate";
import ImageUrlWidget from "./ImageUrlWidget";
import VideoField from "./VideoField";
import CaptionUrlWidget from "./CaptionUrlWidget";
import TranslationsField from "./TranslationsField";

// Uggly hack to fix width of array items. A custom array field might be a better solution.
// also a fix to show hidden delete button in arrays
const StyledForm = styled(Form)`
  .field-array {
    & .MuiGrid-root.MuiGrid-container.MuiGrid-align-items-xs-center {
      & > .MuiGrid-item:nth-child(2) {
        flex-grow: 0;
      }
    }
  }

  button.MuiIconButton-colorSecondary {
    color: red;
  }
`;

export const GenericForm = ({
  id,
  schema,
  uiSchema,
  onSubmit,
  formData = {},
  onChange,
}: {
  id: string;
  schema: RJSFSchema;
  uiSchema: RJSFSchema;
  onSubmit: (data: any) => void;
  formData?: any;
  onChange?: (data: any) => void;
}) => {
  return (
    <StyledForm
      id={id}
      liveValidate
      schema={schema}
      uiSchema={uiSchema}
      formData={formData}
      widgets={{
        ImageUrlWidget: ImageUrlWidget,
        CaptionUrlWidget: CaptionUrlWidget,
      }}
      templates={{
        ...Templates,
        ObjectFieldTemplate: ObjectFieldTemplate,
        ArrayFieldTemplate: CustomArrayFieldTemplate,
      }}
      fields={{
        VideoField: VideoField,
        TranslationsField: TranslationsField,
      }}
      onSubmit={e => {
        if (e.formData && onSubmit) {
          onSubmit(e.formData);
        }
      }}
      validator={validator}
      showErrorList={"bottom"}
      onChange={onChange}
    />
  );
};
